import * as React from "react";
import * as ReactDOM from "react-dom";
import FormEsriLoaderReact from "./FormEsriLoaderReact";
import MapComponents from "./business-objects/MapComponents";

export interface IMapWithExportProps {
  nightMode: boolean;
  isOffline?: boolean;
  esriError?: string;
  mapContainerClassName?: string;
  component: any;
  onReady: (mapComponents: MapComponents) => void;
}

export interface IMapWithExportState {
  mapReady: boolean;
  timedOut: boolean;
}

export default class MapWithExport extends React.Component<IMapWithExportProps, IMapWithExportState> {
  state: IMapWithExportState = {
    mapReady: false,
    timedOut: false
  };

  onError = (error: Error, errorInfo: any) => {
    console.error(error);
  };

  onReady = (mapComponents: MapComponents) => {
    this.setState({ mapReady: true }, () => {
      this.props.onReady(mapComponents);
    });
  };

  addLoadingTimeout = () => {
    setTimeout(() => {
      if (!this.state.mapReady && !this.props.esriError) {
        this.setState({ timedOut: true });
      }
    }, (!!this.props.component.esriLoadTimeoutSeconds && this.props.component.esriLoadTimeoutSeconds * 1000) || 30000);
  };

  componentDidMount() {
    this.addLoadingTimeout();
  }

  render() {
    if (this.props.isOffline) {
      return (
        <div>
          <h3>No internet connection detected</h3>
        </div>
      );
    }

    const errorView = [
      <div className="row" key="esriErrorTextRow">
        <div className="col">
          <h1 className="ui-state-error-text">An unexpected error has occurred!</h1>
          <p>
            Sorry for the inconvenience, but the system is unable to produce the map display at this time due to an
            unexpected error. The issue is logged and will be reviewed by our support staff.
          </p>
          <p>Please reattempt after a delay or by exiting and relaunching the application.</p>
        </div>
      </div>
    ];

    const loadingIndicator = !this.state.mapReady && [
      <div className="row" key="esriLoadingIndicatorRow">
        <div className="col-xs-offset-5 col-xs-2">
          <div className="pace">
            <div
              className="pace-activity"
              style={{
                position: "relative",
                margin: "auto",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                width: 77,
                height: 77,
                borderRadius: "50%"
              }}
            />
          </div>
        </div>
      </div>,
      this.state.timedOut && errorView
    ];

    const esriView = (
      <div className={this.state.mapReady ? undefined : "hidden"} key="esriView">
        <div className="row">
          <div className="col">
            <FormEsriLoaderReact
              component={this.props.component}
              isNightmode={this.props.nightMode}
              onError={(error, errorInfo) => this.onError(error, errorInfo)}
              onReady={this.onReady}
              mapContainerClassName={this.props.mapContainerClassName}
            />
          </div>
        </div>
      </div>
    );

    return this.state.mapReady ? esriView : this.props.esriError ? [errorView, esriView] : [loadingIndicator, esriView];
  }
}
